import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/breathing-exercises.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/code-cracker.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/human-body.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/match-disney.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/match.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/search-find-dinosaurs.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/search-find-princess.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/search-find.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/games/_assets/game-covers/word-guess.png");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.24.5_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.3.8_@babel+core@7.24.5_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/image-component.js");
